<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import api from "@/services/apiService";

import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const route = useRoute();
const router = useRouter();
const store = useStore();

const token = ref("");
const newPassword = ref("");
const confirmPassword = ref("");
const errorMessage = ref("");
const successMessage = ref("");
const showPassword = ref(false);
const showConfirmPassword = ref(false);

const body = document.getElementsByTagName("body")[0];

onBeforeMount(() => {
  token.value = route.query.token;
  if (!token.value) {
    errorMessage.value = "El token de restablecimiento no es válido o ha expirado.";
  }

  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  body.classList.add("bg-gray-100");
});

const handleReset = async () => {
  if (!newPassword.value || newPassword.value.length < 6) {
    errorMessage.value = "La contraseña debe tener al menos 6 caracteres.";
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = "Las contraseñas no coinciden.";
    return;
  }

  try {
    await api.post("/reset-password", {
      token: token.value,
      password: newPassword.value,
    });

    successMessage.value = "Tu contraseña ha sido restablecida correctamente. Ahora puedes iniciar sesión.";
    errorMessage.value = "";

    setTimeout(() => {
      router.push("/signin");
    }, 2000);
  } catch (error) {
    errorMessage.value = error.response?.data?.message || "Error al restablecer la contraseña.";
  }
};
</script>

<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBlur="blur border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow" v-bind:darkMode="true" isBtn="bg-gradient-primary" />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Restablecer Contraseña</h4>
                  <p class="mb-0">Ingresa tu nueva contraseña para continuar</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleReset">
                    <div class="mb-3 position-relative">
                      <argon-input
                        id="newPassword"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Nueva Contraseña"
                        name="newPassword"
                        size="lg"
                        v-model="newPassword"
                      />
                      <i
                        class="fa"
                        :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                        @click="showPassword = !showPassword"
                        style="position: absolute; top: 50%; right: 15px; transform: translateY(-50%); cursor: pointer;"
                      ></i>
                    </div>

                    <div class="mb-3 position-relative">
                      <argon-input
                        id="confirmPassword"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        placeholder="Confirmar Contraseña"
                        name="confirmPassword"
                        size="lg"
                        v-model="confirmPassword"
                      />
                      <i
                        class="fa"
                        :class="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"
                        @click="showConfirmPassword = !showConfirmPassword"
                        style="position: absolute; top: 50%; right: 15px; transform: translateY(-50%); cursor: pointer;"
                      ></i>
                    </div>

                    <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
                    <p v-if="successMessage" class="text-success">{{ successMessage }}</p>

                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="primary" fullWidth size="lg" type="submit">
                        Restablecer Contraseña
                      </argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿Ya tienes una cuenta?
                    <router-link to="/signin" class="text-primary text-gradient font-weight-bold">
                      Iniciar sesión
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{ backgroundImage: `url(${require('@/assets/img/house1.jpeg')})`, backgroundSize: 'cover' }"
              >
                <span class="mask bg-gradient-primary opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Gestión de Alquiler y Venta de Propiedades con ARB"
                </h4>
                <p class="text-white position-relative">
                  Simplifica la administración de alquileres y ventas de inmuebles con ARB. Tu solución eficiente,
                  segura y fácil de usar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
